module.exports = {
    licence:{
        Robot_problem_solved:'Utile',
        Robot_problem_unsolved:'Non utile',
        Robot_emptyMassege_reminder:"Impossibile inviare un messaggio vuoto",
        Robot_massege_ViewMore:'Vedi di più',
        Robot_massege_ViewLess:'Vedi di meno',
        Robot_greetings_1:"Ciao, cosa posso fare per te oggi?",
        Robot_greetings_2:"Cerchi qualcos'altro? Prova a inserire una parola chiave, in modo che possa cercare ulteriori informazioni per aiutarti!",
        Robot_closing_1_1:"Aww, scusate! Sto ancora imparando. ",
        Robot_closing_1_2:"Provi a utilizzare un'altra parola chiave o faccia semplicemente clic",
        Robot_closing_1_login_1:"Aww, scusate! Sto ancora imparando. ",
        Robot_closing_1_login_2:"Prova a usare un'altra parola chiave!",
        Robot_closing_2:'QUI ',
        Robot_closing_3:'e contatta il nostro Team di assistenza. Ti risponderemo il prima possibile!',
        Robot_problem_unsolved_reply:'Sono spiacente, non riusciamo ad aiutarti questa volta. Ho scritto la tua richiesta in modo da migliorare il livello di assistenza fornita la prossima volta! Clicca QUI e contatta il nostro Team di assistenza. Ti risponderemo il prima possibile!',
        Robot_TypeHere:'Digita qui',
        Robot_greetings_label1:'Unisci i dati nella nuova app',
        Robot_greetings_label2:'Perdita di dati dopo la migrazione',
        Robot_greetings_label3:'La bilancia viene disconnessa dopo la migrazione',
        Robot_greetings_label4:'Suggerimenti dopo la migrazione',
        Robot_greetings_label5:'Grafica mostrata nella scheda',
        Robot_greetings_label6:'Visualizza la cronologia del peso',
        Robot_greetings_label7:"Visualizza la cronologia della circonferenza",
        Robot_greetings_label8:'Dove posso ricevere aiuto',
        Robot_greetings_label9:'Altri',
        key_internet_error:"Sono presenti dei problemi di rete. Controlla le impostazioni della tua rete",
        Robot_title_Beta:'ChatBot',
        Robot_greetings_label1_login:'Hai dimenticato la password?',
        Robot_greetings_label2_login:'Come reimpostare la password',
        Robot_greetings_label3_login:'Unisci i dati nella nuova app',
        Robot_greetings_label4_login:'Perché ci sono due app?',
        Robot_greetings_label5_login:"Note per l'accesso all'account",
        Robot_greetings_label6_login:"La nuova app necessita di una nuova registrazione?",
        Robot_greetings_label7_login:"Cosa fare se ho un account su entrambe le app",
        Robot_greetings_label8_login:'Dove posso ricevere aiuto',
        Robot_greetings_label9_login:'Altri',
        Robot_greetings_label1_devicePage:'Modi per aggiungere un dispositivo',
        Robot_greetings_label2_devicePage:'Aggiungi dispositivo tramite il popup ""Aggiungi dispositivo',
        Robot_greetings_label3_devicePage:'Aggiungi dispositivo manualmente',
        Robot_greetings_label4_devicePage:"Suggerimenti per l'abbinamento della bilancia Wi-Fi-Bluetooth",
        Robot_greetings_label5_devicePage:'Come abbinare tramite Wi-Fi',
        Robot_greetings_label6_devicePage:"Il dispositivo non è elencato in 'DISPOSITIVI ASSOCIATI'",
        Robot_greetings_label7_devicePage:"Elimina un dispositivo",
        Robot_greetings_label8_devicePage:'Dove posso ricevere aiuto',
        Robot_greetings_label9_devicePage:'Altri',
        Robot_greetings_label1_mePage:"Posso cambiare l'utente principale?",
        Robot_greetings_label2_mePage:"Come modificare le informazioni dell'utente principale",
        Robot_greetings_label3_mePage:'Visualizzare i dati di un amico',
        Robot_greetings_label4_mePage:'Aggiungi un amico',
        Robot_greetings_label5_mePage:'Come inviare la richiesta di amicizia',
        Robot_greetings_label6_mePage:"Come controllare la richiesta di amicizia",
        Robot_greetings_label7_mePage:"Elimina un amico",
        Robot_greetings_label8_mePage:'Dove posso ricevere aiuto',
        Robot_greetings_label9_mePage:'Altri',
        Robot_greetings_label1_balancePage:"I dati sul peso non vengono sincronizzati con l'APP",
        Robot_greetings_label2_balancePage:"Come controllare l'errore del Bluetooth",
        Robot_greetings_label3_balancePage:"L'app mostra solo peso e BMI",
        Robot_greetings_label4_balancePage:'"Le letture muscolari vengono visualizzate in ""--"""',
        Robot_greetings_label5_balancePage:'La bilancia pesa in modo errato',
        Robot_greetings_label6_balancePage:"La lettura della percentuale di grasso corporeo cambia drasticamente",
        Robot_greetings_label7_balancePage:"Inserisci manualmente i dati sul peso",
        Robot_greetings_label8_balancePage:'Passare a un altro utente di misurazione',
        Robot_greetings_label9_balancePage:'Altri',
        Robot_greetings_label1_tapPage:'Come usare il metro a nastro',
        Robot_greetings_label2_tapPage:'Passa alla misurazione di un altro utente',
        Robot_greetings_label3_tapPage:'Visualizza il grafico delle tendenze della circonferenza',
        Robot_greetings_label4_tapPage:'Visualizza la cronologia della circonferenza',
        Robot_greetings_label5_tapPage:'Inserisci manualmente i dati sulla circonferenza',
        Robot_greetings_label6_tapPage:"Dove posso ricevere aiuto",
        Robot_greetings_label7_tapPage:"Altri",
        savetoAlbum: "Salvato nell'album",
        key_cancel: 'Cancella',
        key_confirm: 'Conferma',
        key_deleted: 'Eliminata con successo',
        key_delete_popup: "La cronologia non verrà recuperata dopo l'eliminazione: assicurati di volerla eliminare.",
        key_delete_history: 'Elimina la cronologia della chat',
        key_delete_confirmation: 'Conferma eliminazione'
    }
}